<script src="../../../../store/module/clientaccountserv.js"></script>
<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加客户信息"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="clientInfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="clientInfo.name" placeholder="请输入客户名称">
        </Input>
      </FormItem>
      <FormItem prop="phoneNum">
        <Input v-model="clientInfo.phoneNum" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Input v-model="clientInfo.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'AddClientInfoModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '客户名称不能为空', trigger: 'blur' }
          ]
        }
      },
      phoneNumRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '联系电话不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        clientInfo: {
          name:null,
          phoneNum:null,
          address:null,
          userId:null,
          invalid:false,
        }
      }
    },
    methods: {
      ...mapActions([
        'ClientInfoServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加用户信息',
          content: '<p>是否确认添加用户信息</p>',
          onOk: () => {
            if(this.businessUserId){
              this.clientInfo.userId = this.businessUserId
            }
            store.dispatch('ClientInfoServ_AddObj', {params: this.clientInfo}).then(() => {
              this.$Message.success('添加用户信息成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.clientInfo.name = null
          this.clientInfo.phoneNum = null
          this.clientInfo.address = null
          this.clientInfo.userId = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
